module.exports = __webpack_public_path__ + "img/img_slide_tit.fa3019a0.svg";